type MarqueeItem = Readonly<{
	usePetitionPhoto: boolean;
	petition: Readonly<{
		photo: Readonly<{ petitionSquare: Readonly<{ url: string }> }> | null;
		user: Readonly<{ photo: Readonly<{ userMedium: Readonly<{ url: string }> }> | null }>;
	}>;
}>;

/**
 * The image a marquee card shows: the starter's avatar, else the petition photo.
 *
 * Curators set usePetitionPhoto on starters whose avatar is an auto-generated letter rather
 * than a real photo - we can't tell those apart from the URL, so the flag skips the avatar
 * entirely rather than falling back to it.
 *
 * Returns undefined when the entry has no usable image, in which case the card is dropped
 * rather than shown with a placeholder.
 */
export function getMarqueeCardImageUrl({ usePetitionPhoto, petition }: MarqueeItem): string | undefined {
	const petitionPhotoUrl = petition.photo?.petitionSquare.url;
	if (usePetitionPhoto) return petitionPhotoUrl;

	return petition.user.photo?.userMedium.url || petitionPhotoUrl;
}
